import { DateTime } from 'luxon'

import { ContentCategoryDto } from '@core/api/dtos/response/contentCategory/contentCategory'
import { ContentCategory } from '@core/api/entities/contentCategory'

export class ContentCategoryMapper {
	static toEntity(dto: ContentCategoryDto): ContentCategory {
		const parent = dto.parent?.data
			? ContentCategoryMapper.toEntity(dto.parent.data)
			: undefined

		const subcategories = dto.subcategories?.data
			? dto.subcategories.data.map((sub) => ContentCategoryMapper.toEntity(sub))
			: undefined

		return new ContentCategory({
			id: dto.id,
			name: dto.name,
			key: dto.key,
			parentId: dto.parent_id,
			tags: dto.tags ?? [],
			showInSchedules: dto.show_in_schedules,
			showInPlaylists: dto.show_in_playlists,
			autoHideAtSchedules: dto.auto_hide_at_schedules
				? DateTime.fromISO(dto.auto_hide_at_schedules)
				: null,
			autoHideAtPlaylists: dto.auto_hide_at_playlists
				? DateTime.fromISO(dto.auto_hide_at_playlists)
				: null,
			positionSchedules: dto.position_schedules,
			positionPlaylists: dto.position_playlists,
			createdAt: DateTime.fromISO(dto.created_at),
			updatedAt: DateTime.fromISO(dto.updated_at),
			parent,
			subcategories,
		})
	}

	static toEntities(dtos: ContentCategoryDto[]): ContentCategory[] {
		return dtos.map((dto) => ContentCategoryMapper.toEntity(dto))
	}
}
